<template>
  <div>
    <TopOfMonth />
    <div class="card">
      <h2>Torneos</h2>
      <div class="row">
        <div class="col">
          <label>Juego</label>
          <select class="input" v-model="game">
            <option value="">Todos</option>
            <option v-for="g in games" :key="g.code" :value="g.code">{{ g.name }} ({{ g.code }})</option>
          </select>
        </div>
        <div class="col">
          <label>Desde</label>
          <input class="input" type="date" v-model="from">
        </div>
        <div class="col">
          <label>Hasta</label>
          <input class="input" type="date" v-model="to">
        </div>
        <div class="col" style="align-self:flex-end;">
          <button class="btn" @click="load">Buscar</button>
        </div>
      </div>
    </div>

    <div class="card" v-for="t in tournaments" :key="t.tournamentId">
      <div class="row" style="align-items:center;">
        <div class="col">
          <h3 style="margin:0;">{{ t.title }}</h3>
          <p style="margin:0;"><span class="badge">{{ t.game }}</span> • {{ formatDate(t.eventDate) }}</p>
        </div>
        <div class="col" style="text-align:right;">
          <router-link class="btn" :to="'/tournaments/' + t.tournamentId">Ver</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api';
import TopOfMonth from "@/components/TopOfMonth.vue";
export default {
  components: {TopOfMonth},
  data: () => ({ tournaments: [], games: [], game: '', from: '', to: '' }),
  async created() {
    const g = await api.get('/api/games'); this.games = g.data;
    await this.load();
  },
  methods: {
    async load() {
      const params = {};
      if (this.game) params.game = this.game;
      if (this.from) params.from = this.from;
      if (this.to) params.to = this.to;
      const { data } = await api.get('/api/tournaments', { params });
      this.tournaments = data;
    },
    formatDate(d) {
      return new Date(d).toLocaleDateString();
    }
  }
}
</script>
